<div class="container">
  <div class="select-file-group">
    <button
      class="select-file-button"
      type="button"
      mat-stroked-button
      (click)="skuFileUploadInput.click()"
      color="accent"
      [disabled]="uploading"
    >
      Select File
    </button>
    <input hidden (change)="onFileSelected()" #skuFileUploadInput type="file" id="sku-file-upload-input" />

    <span *ngIf="selectedFile" class="selected-file">
      <span class="file-name">{{ selectedFile?.name }} </span>
      <div>
        <span class="file-last-modified">{{ selectedFile?.lastModified | date: "short" }}</span>
        <span class="file-size">({{ selectedFile?.size | fileSize }}) </span>
      </div>
    </span>
  </div>
  <div class="upload-file-group">
    <button
      class="upload-file-button"
      type="button"
      mat-stroked-button
      (click)="uploadSkuFile()"
      color="accent"
      [disabled]="!selectedFile || uploading"
    >
      Upload File
    </button>

    <span class="spinner" *ngIf="uploading">
      <mat-progress-spinner color="accent" [mode]="spinnerMode" [value]="spinnerValue" strokeWidth="5" diameter="25">
      </mat-progress-spinner>
    </span>
    <span class="upload-status" *ngIf="uploading">{{ uploadStatus }}</span>

    <span *ngIf="lastUploaded" class="uploaded-file">
      <span>Successfully uploaded </span><span> '{{ lastUploaded?.name }}'</span>
    </span>

    <span *ngIf="error" class="uploaded-file error">
      <span>{{ error }}</span>
    </span>
  </div>
</div>
